<div class="vcard">
  <div class="columnTwoThird">
    <h1>
      @if (!isEmpty(person.title)) {
        <span>{{person.title.shorttext}} </span>
      }
      <!-- If possible change to usage of academicdegree.position_of_title -->
      @if (!isEmpty(person.academicdegree) && isPrefixTitle()) {
        <span>{{person.academicdegree.shorttext}} {{person.academicdegreesuffix}} </span>
      }
      <span>{{person.firstname}} </span>
      @if (!isEmpty(person.nameprefix)) {
        <span>{{person.nameprefix}} </span>
      }
      <span>{{person.surname}}</span>
      @if (!isEmpty(person.namesuffix)) {
        <span> {{person.namesuffix}}</span>
      }
      @if (!isEmpty(person.academicdegree) && !isPrefixTitle()) {
        <span>, {{person.academicdegree.shorttext}} {{person.academicdegreesuffix}}</span>
      }
      <br />
      @if (!isEmpty(person.artistname)) {
        <span>WIP: Künstlername</span>
      }
    </h1>

    <div class="contact">
      @if (postAddresses?.length) {
        <div class="columnOneThird">
          <psv-person-detail-view-addresses [addresses]="postAddresses"></psv-person-detail-view-addresses>
        </div>
      }
      @if (eAddresses?.length) {
        <div class="columnTwoThird">
          <psv-person-detail-view-contactdata [eAddresses]="eAddresses"></psv-person-detail-view-contactdata>
        </div>
      }
    </div>
    <div class="clearer"></div>
    <br />
    @if (!isEmpty(person.affiliations)) {
      <div class="affiliation">
        @for (affiliation of person.affiliations; track affiliation; let i = $index) {
          <div>
            <!-- Siehe Ticket 298012: Aufruf des Orgunit Baumes nur dem richtigen Recht -->
            @if (showOrgunitTreeLink === false && isEmpty(affiliation.location) && isEmpty(affiliation.eaddresses)) {
              <div>
                <strong>{{affiliation.organization.text}} &ndash; {{affiliation.affiliationType.text}}@if (affiliation.supplement) {
                  {{affiliation.supplement}}
                }</strong>
                <div class="clearer"></div>
              </div>
            } @else {
              @if (!toggleContact[i]) {
                <button (click)="toggleContactDataForAffiliation(true, i)"
                  class="icon" title="{{'cs.psv.person.affiliation.showContactdata' | hisUi}}">
                  <strong>{{affiliation.organization.text}} &ndash; {{affiliation.affiliationType.text}}@if (affiliation.supplement) {
                    {{affiliation.supplement}}
                  }</strong>
                  <img hisImage="ARROW_RIGHT_V" class="inlineicon" title="{{ ('view.images.plus_circ' | hisUi) }}">
                </button>
              }
              @if (toggleContact[i]) {
                <button (click)="toggleContactDataForAffiliation(false, i)"
                  class="icon" title="{{'cs.psv.person.affiliation.hideContactdata' | hisUi}}">
                  <strong>{{affiliation.organization.text}} &ndash; {{affiliation.affiliationType.text}}@if (affiliation.supplement) {
                    {{affiliation.supplement}}
                  }</strong>
                  <img hisImage="ARROW_UP_V" class="inlineicon" title="{{ ('view.images.minus_circ' | hisUi) }}">
                </button>
              }
              <br />
            }
            <br/>
            @if (toggleContact[i]) {
              <!--  Siehe Ticket 298012: Aufruf des Orgunit Baumes nur dem richtigen Recht -->
              @if (showOrgunitTreeLink === true) {
                <div>
                  <a title="{{ 'cs.psv.orgunit.publicOrgunit.showOrgunitTree' | hisUi}}" class="singleLine transparent"
                    href="../../pages/startFlow.xhtml?_flowId=showPublicOrgunitHierarchy-flow&personOrgunitRelationId={{affiliation.id}}&object=PersonOrgunitRelation&showOrgunitTree=true&backToPersonProfile=true&navigationPosition=organisation,hisinonepubliceinrichtungsstruktur"
                  hisImage="CHART_ORGANISATION">{{ 'cs.psv.orgunit.publicOrgunit.showOrgunitTree' | hisUi}}</a>
                  <br /><br />
                </div>
              }
              <div class="contact">
                <br />
                @if (!isEmpty(affiliation.location) || !isEmpty(affiliation.eaddresses)) {
                  <div class="layoutBlock">
                    @if (affiliation.location) {
                      <div class="columnOneThird">
                        <psv-person-detail-view-addresses [addresses]="[affiliation.location]"></psv-person-detail-view-addresses>
                      </div>
                    }
                    <br />
                    @if (affiliation.eaddresses) {
                      <div class="columnTwoThird">
                        <psv-person-detail-view-contactdata [eAddresses]="affiliation.eaddresses"></psv-person-detail-view-contactdata>
                      </div>
                    }
                  </div>
                }
                @if (i < person.affiliations.length-1) {
                  <br />
                }
              </div>
            }
            <div class="clearer"></div>
          </div>
        }
      </div>
    }
  </div>
  <div class="columnOneThird">
    <!-- 	WIP: Profilbild (aus PSV?)
    <img src="person.picture" alt="getFullPersonNameAndTitle()"
      title="{{'psv.Person' | hisUi}}: getFullPersonNameAndTitle()" class="detailpagePersonFoto">
  --></div>
  <div class="clearer"></div>
</div>
